import { TipoSuministroTramiteEnergiaEnum, type CoordenadaFirma, type CreateServicioEnergiaModel, type DescuentoEnergiaModel, type DetailServicioEnergiaModel } from '@api/api';
import { toUTCDateOnly } from '@helpers/date-parser-helper';

export class CreateServicioEnergia implements CreateServicioEnergiaModel {

  IdEmpresaServicios: string = '';
  Nombre: string = '';
  FechaInicio: Date = new Date();
  FechaFin: Date = new Date();
  TipoEnergia: TipoSuministroTramiteEnergiaEnum = TipoSuministroTramiteEnergiaEnum.Luz;
  Descripcion: string = '';
  Coste: number = 0.0;
  AplicaPersonaFisica: boolean = false;
  AplicaPersonaJuridica: boolean = false;
  Excluyente: boolean = false;
  Observaciones: string | null = null;
  Activa: boolean = true; 
  CoordenadasFirma: CoordenadaFirma[] = [];
  EmpresaServicios: string = '';
  DenominacionInterna: string | null = null;
  Descuentos: DescuentoEnergiaModel[] = [];

  constructor(data?: Partial<CreateServicioEnergia>) {
    Object.assign(this, data);

    if (data?.FechaFin == null)
      this.FechaFin.setDate(this.FechaFin.getDate() + 1)

    this.FechaInicio = toUTCDateOnly(this.FechaInicio);
    this.FechaFin = toUTCDateOnly(this.FechaFin);
  }

  public createFromServicioDetail(oferta: DetailServicioEnergiaModel): CreateServicioEnergia{
    Object.assign(this, oferta);
    return this;
  }

}